module.exports = {"name":"primetime","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.2.0","built":"2018-06-18","repo":"https://bitbucket.org/npaw/primetime-adapter-js","libVersion":"6.2.6","features":{"buffer":"native","seek":"native","getters":["getPlayhead","getPlayrate","getFramesPerSecond","getDroppedFrames","getDuration","getBitrate","getThroughput","getRendition","getIsLive","getResource"]},"ads":[{"buffer":"monitor","seek":"monitor","getters":["getPlayhead","getDuration","getTitle","getResource","getPosition"],"filename":"primetimeAds.js"}]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 15
// module chunks = 0